export default class PagingValidation {

    public static validate(itemsPerPage: number): boolean {
        if (itemsPerPage > 99) {
            alert('100件以上の表示はできません。');
            return false;
        }
        return true;
    }
}